/// <reference types="google.maps" />
declare global {
    interface Window {
        google: typeof google
    }
}
export {}

let loaderPromise: Promise<typeof google> | null = null

export function useGoogleMapsLoader() {
    const config = useRuntimeConfig()

    if (!loaderPromise) {
        loaderPromise = new Promise((resolve, reject) => {
            // SSR guard
            if (typeof window === 'undefined') {
                reject(new Error('Google Maps can only be loaded on client'))
                return
            }

            if (window.google?.maps) {
                resolve(window.google)
                return
            }

            const script = document.createElement('script')
            script.src = `https://maps.googleapis.com/maps/api/js?key=${config.public.googleMapsApiKey}&libraries=maps,marker`
            script.async = true
            script.defer = true
            script.onload = () => resolve(window.google)
            script.onerror = reject
            document.head.appendChild(script)
        })
    }

    return loaderPromise
}
